import { ActionBar, media, T2 } from 'ia-react-core';
import Lottie from 'lottie-react';
import styled from 'styled-components';

export const StyledList = styled.ul`
   padding-bottom: 36px;
   padding-top: 2px;
   margin-top: 0px;
   margin-bottom: 0px;
  padding-left: 0;
  li {
      list-style: none;
      font-size: 14px;
      line-height: 20px;
  }
  
  li::before {
      content:"·";
      font-size:30px;
      vertical-align:bottom;
      margin-right: 5px;
  }
`;
export const StyledText = styled.p`
   padding-top: 16px;
   margin-top: 0px;
   margin-bottom: 0px;
   font-size: 14px;
      line-height: 18px;

  ${media.sm`
  padding-top: 24px;
  `}
`;

export const StyledBackgroundDiv = styled.div`
   background-color: ${({ theme }) => theme.colors.blue12};
    height: 240px;
    padding-bottom: 28px;
    padding-top: 4px;
    padding-right: 30px;
    padding-left: 30px;
    ${media.sm`
    height: 380px;
    padding-bottom: 41px;
  `};
`;

export const StyledLottie = styled(Lottie)`
display: contents;
`;
export const StyledActionBar = styled(ActionBar)`
  padding-top: 0px;
  display: flex;

`;
export const StyledTitle = styled(T2)`
     margin-bottom: 0px;
`;
export const StyledDiv = styled.div`
  padding-top: 48px;
  padding-right: 16px;
  padding-bottom: 48px;
  padding-left: 16px;
  ${media.sm`
  padding-right: 32px;
  padding-left: 32px;

  `};

`;
